import React from 'react'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { isFlowTheme } from 'src/Libs/utils'
import SystemCharts from './SystemCharts'
import { UseChartsFunctions } from 'src/Libs/dashboard/hooks/use-charts-functions'
import PocSystemCharts from './PocSystemCharts'
import { useUpdateEditedChartSettings } from 'src/Libs/chart-kit'
import useDefaultAndCustomCharts from '../hooks/use-default-and-custom-charts'
import { UserSettings } from 'src/Libs/user/types'

interface Props {
  storageId?: string
  installationId?: string
  hide: boolean
  showSavingsPieChart: boolean
  isSavingsChartLoading: boolean
  userSettings: UserSettings
  systemChartProps: UseChartsFunctions
}

/**
 * Container component to render the appropriate system charts based on feature flag settings and theme.
 *
 * @param param0
 * @returns
 */
const SystemChartContainer: React.FC<Props> = ({
  storageId,
  userSettings,
  installationId,
  hide,
  showSavingsPieChart,
  isSavingsChartLoading,
  systemChartProps,
}) => {
  const {
    featureFlags: { chartSelector },
    isFeatureFlagsLoading,
  } = useFeatureFlagsContext()
  const showPerformantChart = !isFlowTheme && !isFeatureFlagsLoading && (chartSelector.performance || chartSelector.both)
  const showPocPerformantChart = !isFeatureFlagsLoading && (chartSelector.poc || chartSelector.both)

  const { defaultAndCustomCharts } = useDefaultAndCustomCharts(userSettings)
  const { saveCharts } = useUpdateEditedChartSettings(defaultAndCustomCharts)

  if (showPerformantChart) {
    return (
      <SystemCharts
        storageId={storageId}
        installationId={Number(installationId)}
        hide={hide}
        showSavingsPieChart={showSavingsPieChart}
        isSavingsChartLoading={isSavingsChartLoading}
        {...systemChartProps}
      />
    )
  }

  if (showPocPerformantChart) {
    return (
      <PocSystemCharts
        storageId={storageId}
        installationId={Number(installationId)}
        hide={hide}
        showSavingsPieChart={showSavingsPieChart}
        isSavingsChartLoading={isSavingsChartLoading}
        defaultAndCustomCharts={defaultAndCustomCharts}
        saveCustomChart={saveCharts}
        {...systemChartProps}
      />
    )
  }

  return <></>
}

export default SystemChartContainer
